/// <amd-module name="hypo_elements/Partials/ModalLink/ModalLink"/>
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define("hypo_elements/Partials/ModalLink/ModalLink", ["require", "exports", "hypo_elements/Partials/ModalFenster/ModalFenster", "jquery"], function (require, exports, modalFenster) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    modalFenster = __importStar(modalFenster);
    $(function () {
        $(".modalLink:not([data-target])").each(function (index, element) {
            var $element = $(element);
            $element.on("click", function (event) {
                event.preventDefault();
                var url = $element.attr("href");
                modalFenster.showModal(url, { wrapperClass: $element.data("wrapper-class") });
            });
        });
    });
});
